<template>
  <div class="noAlTope">
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <b-row v-if="cargando" class="text-center">
      <b-col>
        <b-button variant="primary" disabled>
          <b-spinner small></b-spinner>
          Cargando...
        </b-button>
      </b-col>
    </b-row>

    <b-form v-on:submit.prevent="guardarSaldo" v-else>
      <label>Saldo a favor actual: </label>
      <b-form-input
        type="number"
        v-model.number="balance.totalSaldo"
        :state="balance.totalSaldo != null"
        required
      >
      </b-form-input>
      <b-form-invalid-feedback :state="balance.totalSaldo != null">
        Debe colocar un número
      </b-form-invalid-feedback>

      <div class="text-center">
        <b-button
          type="submit"
          class="mt-4"
          variant="outline-primary"
          v-if="!enviando"
        >
          Guardar
        </b-button>

        <b-button class="mt-4" variant="primary" disabled v-else>
          <b-spinner small></b-spinner>
          Cargando...
        </b-button>
      </div>
    </b-form>
  </div>
</template>

<script>
import VueNotifications from "vue-notifications";

export default {
  name: "SaldoFavorModal",
  props: {
    idPaciente: {
      type: Number,
      required: true,
    },
  },
  data: () => ({
    balance: null,
    cargando: true,
    enviando: false,
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
  }),
  created() {
    this.traerSaldoFavorPaciente();
    this.debug = this.$localStorageService.getDebug();
  },
  methods: {
    traerSaldoFavorPaciente() {
      const parametros = {idPaciente: this.idPaciente}
      const url = this.$api + "kpi/obtener";

      this.$http
        .post(url, parametros)
        .then((response) => {
          if (response.data.data) {
            this.balance = response.data.data;
            if (response.data.data.idBalance == null) {
              this.balance.totalSaldo = 0;
            }
          }
        })
        .finally(() => {
          this.cargando = false;
        });
    },
    guardarSaldo() {
      this.enviando = true;

      if (this.balance.idBalance != null) {
        this.actualizarBalance();
      } else {
        this.balance.idPaciente = this.idPaciente;
        this.crearNuevoBalance();
      }
    },
    crearNuevoBalance() {
      const url = this.$api + "kpi";

      this.$http
        .post(url, this.balance)
        .then((response) => {
          if (response.status === 200) {
            this.$swal({
              icon: "success",
              text: "Se envio la información correctamente",
              confirmButtonText: "OK",
              confirmButtonColor: "#0e6ba9",
            });

            setTimeout(() => location.reload(), 2000);
          }
        })
        .finally(() => {
          this.enviando = false;
        });
    },
    actualizarBalance() {
      const url = this.$api + "kpi";

      this.$http
        .put(url, this.balance)
        .then((response) => {
          if (response.status === 200) {
            this.$swal({
              icon: "success",
              text: "Se envio la información correctamente",
              confirmButtonText: "OK",
              confirmButtonColor: "#0e6ba9",
            });

            setTimeout(() => location.reload(), 2000);
          }
        })
        .finally(() => {
          this.enviando = false;
        });
    },
  },
  notifications: {
    errorEnvio: {
      type: VueNotifications.types.error,
      title: "Error",
      message: "Error al enviar la información",
    },
  },
};
</script>

<style>
</style>